import { addDays, isBefore, startOfHour } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const displayTimeValue = (value: number) => {
  return String(value).padStart(2, "0");
};

export function getNext2amUTCDate(now = new Date()): Date {
  // Get the current UTC time
  const currentUTCDate = now;

  // Convert the current UTC time to a date object representing UTC time zone
  const currentZonedTime = utcToZonedTime(currentUTCDate, "Etc/UTC");

  // Calculate 2AM of the current day in the UTC time zone
  let next2amZonedTime = startOfHour(
    new Date(
      currentZonedTime.getFullYear(),
      currentZonedTime.getMonth(),
      currentZonedTime.getDate(),
      2,
      0,
      0
    )
  );

  // If current time is after 2AM, we add one day
  if (!isBefore(currentZonedTime, next2amZonedTime)) {
    next2amZonedTime = addDays(next2amZonedTime, 1);
  }

  // Convert the 2AM zoned time back to UTC time
  return zonedTimeToUtc(next2amZonedTime, "Etc/UTC");
}

export const differenceInMinutes = (date: Date) => {
  const now = new Date();
  const difference = Math.abs(now.getTime() - date.getTime());
  const millisecondsPerMinute = 60 * 1000;
  return Math.floor(difference / millisecondsPerMinute);
};

export const getTimeOfDay = () => {
  const now = new Date();
  const hour = now.getHours();
  if (hour >= 5 && hour < 12) return "isMorning";
  if (hour >= 12 && hour <= 13) return "isNoon";
  if (hour > 13 && hour <= 17) return "isAfternoon";
  if (hour > 17 && hour <= 21) return "isEvening";
  return "isNight";
};
